import { useState } from 'react';
import { Button, Input, Space, message } from 'antd';
import { SaveOutlined } from '@ant-design/icons';
import { WisecureCard } from '@/components/base';
import { useSecurityRequestUpdate } from './useSecurityRequestUpdate';

interface AdminNoteCardProps {
  id: string;
  /** Saved note. Remount the card (key) when it changes on the server. */
  note?: string | null;
}

export function AdminNoteCard({ id, note }: AdminNoteCardProps) {
  const [draft, setDraft] = useState(note ?? '');
  const update = useSecurityRequestUpdate();
  const dirty = draft.trim() !== (note ?? '').trim();

  const save = () => {
    update.mutate(
      { id, body: { adminNote: draft } },
      {
        onSuccess: () => message.success('Note enregistrée'),
        onError: () => message.error("Impossible d'enregistrer la note"),
      },
    );
  };

  return (
    <WisecureCard title="Note interne" size="small">
      <Space direction="vertical" style={{ width: '100%' }}>
        <Input.TextArea
          value={draft}
          onChange={(e) => setDraft(e.target.value)}
          placeholder="Ex. : rappelé le 30/10, devis envoyé."
          autoSize={{ minRows: 4, maxRows: 12 }}
          maxLength={2000}
          showCount
        />
        <div style={{ textAlign: 'right', marginTop: 12 }}>
          <Button type="primary" icon={<SaveOutlined />} onClick={save} loading={update.isPending} disabled={!dirty}>
            Enregistrer
          </Button>
        </div>
      </Space>
    </WisecureCard>
  );
}
